import { combineReducers, createSlice, PayloadAction } from '@reduxjs/toolkit';

import floorBuilderReducer from './floor-builder/slice';
import floorPlanReducer from './floor-plan/slice';
import hostViewReducer from './host-view/slice';

export enum VenueType {
	HOST_VIEW = 'host-view',
	FLOOR_PLAN = 'floor-plan',
	FLOOR_BUILDER = 'floor-builder',
	FLOOR_COMBOS = 'floor-combos',
}

interface VenueState {
	view: VenueType;
}

const initialState: VenueState = {
	view: VenueType.HOST_VIEW,
};

const venueSlice = createSlice({
	name: 'venue',
	initialState,
	reducers: {
		setVenueView: (state, action: PayloadAction<VenueType>) => {
			state.view = action.payload;
		},
	},
});

const venueReducer = combineReducers({
	venue: venueSlice.reducer,
	hostView: hostViewReducer,
	floorPlan: floorPlanReducer,
	floorBuilder: floorBuilderReducer,
});

export const selectVenueView = (state) => state.venue.venue.view;

export const { setVenueView } = venueSlice.actions;

export default venueReducer;
